import * as React from "react"
import * as TooltipPrimitive from "@radix-ui/react-tooltip"
import { cn } from "../../lib/utils"

function TooltipProvider({
   delayDuration = 0,
   ...props
}) {
   return (
      <TooltipPrimitive.Provider
         data-slot="tooltip-provider"
         delayDuration={delayDuration}
         {...props}
      />
   )
}

function Tooltip({
   ...props
}) {
   return (
      <TooltipProvider>
         <TooltipPrimitive.Root data-slot="tooltip" {...props} />
      </TooltipProvider>
   )
}

function TooltipTrigger({
   ...props
}) {
   return <TooltipPrimitive.Trigger data-slot="tooltip-trigger" {...props} />
}

function TooltipContent({
   className,
   sideOffset = 0,
   children,
   ...props
}) {
   return (
      <TooltipPrimitive.Portal>
         <TooltipPrimitive.Content
            data-slot="tooltip-content"
            sideOffset={sideOffset}
            className={cn(
               "bg-(--containerBackgroundColor) z-[9999]! border! border-(--borderColor)! text-(--textColor) animate-in! fade-in-0! zoom-in-95! data-[state=closed]:animate-out! data-[state=closed]:fade-out-0! data-[state=closed]:zoom-out-95! data-[side=bottom]:slide-in-from-top-2! data-[side=left]:slide-in-from-right-2! data-[side=right]:slide-in-from-left-2! data-[side=top]:slide-in-from-bottom-2! z-50! w-fit origin-(--radix-tooltip-content-transform-origin) rounded-(--borderRadius)! px-3.5! py-2! text-xs! text-balance!",
               className
            )}
            {...props}
         >
            {children}
            {/* <TooltipPrimitive.Arrow className="bg-(--containerBackgroundColor)! stroke-red-400! fill-(--containerBackgroundColor)! z-50! size-2.5! translate-y-[calc(-50%_-_2px)]! rotate-0! rounded-[2px]" /> */}
         </TooltipPrimitive.Content>
      </TooltipPrimitive.Portal>
   )
}

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider }